<template>
  <div>
    <b-table
     fixed
     striped hover :items="resultData"
      :fields="fields"
       :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
        :tbody-tr-class="rowClass">
    </b-table>
  </div>
</template>

<script>

export default {
  name: 'HomeList',
  data () {
    return {
      sortBy: 'date_key',
      sortDesc: true,
      fields: [
        {
          key: 'date',
          label: ' 日付 '
        },
        {
          key: 'fever',
          label: ' 体温 '
        },
        {
          key: 'features',
          label: '症状'
        },
        {
          key: 'postal_code',
          label: 'エリア'
        }
      ]
    }
  },
  props: {
    resultData: {},
    feaures: []
  },
  created () {
    console.log(this.resultData)
  },
  methods: {
    rowClass (item, type) {
      if (!item || type !== 'row') return
      if (item.features !== 'なし') return 'table-warning'
      if (Number(item.fever) >= 37.5) return 'table-danger'
    }
  }
}
</script>
